import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { Laboratorio } from './laboratorios.model';

// LOAD
export const entityLaboratoriosLoadRequest = createAction(
  '[ENTITYLABORATORIOS] Load Request'
);

export const entityLaboratoriosLoadFailure = createAction(
  '[ENTITYLABORATORIOS] Load Failure',
  props<{ error: Error }>()
);

export const entityLaboratoriosLoadSuccess = createAction(
  '[ENTITYLABORATORIOS] Load Success',
  props<{ items: Laboratorio[] }>()
);

// ADD
export const entityLaboratoriosAddRequest = createAction(
  '[ENTITYLABORATORIOS] Add Request',
  props<{ item: Laboratorio[] }>()
);

export const entityLaboratoriosAddFailure = createAction(
  '[ENTITYLABORATORIOS] Add Failure',
  props<{ error: Error }>()
);

export const entityLaboratoriosAddSuccess = createAction(
  '[ENTITYLABORATORIOS] Add Success',
  props<{ item: Laboratorio[] }>()
);

// DELETE

export const entityLaboratoriosDeleteRequest = createAction(
  '[ENTITYLABORATORIOS] Delete Request',
  props<{ item: Laboratorio }>()
);

export const entityLaboratoriosDeleteFailure = createAction(
  '[ENTITYLABORATORIOS] Delete Failure',
  props<{ error: Error }>()
);
export const entityLaboratoriosDeleteSuccess = createAction(
  '[ENTITYLABORATORIOS] Delete Success',
  props<{ item: Laboratorio }>()
);
